.shell {
  display: grid;
  grid-template-columns: var(--w-sidebar) minmax(0, 1fr);
  min-height: 100vh;
}

/* ------------------------------------------------------------- Sidebar */

.sidebar {
  background-image: var(--grad-d);
  background-origin: border-box;
  color: var(--text-inverse);
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  padding: var(--sp-6) var(--sp-3);
  position: sticky;
  top: 0;
  height: 100vh;
}

.sidebar__brand {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: 0 var(--sp-3);
}

.sidebar__mark {
  width: 32px;
  height: 32px;
  border-radius: var(--r-tiny);
  background: var(--on-green-3);
  display: grid;
  place-items: center;
  color: var(--text-inverse);
  flex: 0 0 auto;
}

.sidebar__name {
  font-size: var(--fs-body);
  line-height: var(--lh-body);
  font-weight: var(--fw-bold);
  color: var(--text-inverse);
}

.sidebar__sub {
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  color: var(--text-inverse-muted);
}

/* `margin-bottom: auto` прижимает всё, что после навигации — блок персоны и
   подпись — к низу колонки. Двух `margin-top: auto` подряд быть не должно:
   свободное место разделилось бы поровну и разорвало подвал. */
.sidebar__nav {
  display: grid;
  gap: 2px;
  margin-bottom: auto;
}

/* Раздел внутри навигации: «Управление» у диспетчера. Линия сверху отделяет
   его от станции, подпись называет, чем он отличается. */
.sidebar__group {
  margin-top: var(--sp-4);
  padding: var(--sp-3) var(--sp-3) var(--sp-1);
  border-top: 1px solid var(--on-green-line);
  font-size: var(--fs-label);
  line-height: var(--lh-label);
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  font-weight: var(--fw-bold);
  color: var(--text-inverse-muted);
}

/* Свёрнутый раздел «Администрирование данных» (agroai-0yt.2). */
.sidebar__fold { display: grid; gap: 2px; }
.sidebar__fold > summary { list-style: none; cursor: pointer; display: flex; align-items: center; justify-content: space-between; }
.sidebar__fold > summary::-webkit-details-marker { display: none; }
/* Шеврон рисуется рамкой, а не глифом «▸»: в шрифте интерфейса глиф
   выходил точкой (agroai-6al.38). */
.sidebar__fold > summary::after { content: ""; width: 6px; height: 6px; margin-right: var(--sp-1); border-right: 1.5px solid currentColor; border-bottom: 1.5px solid currentColor; transform: rotate(-45deg); transition: transform 0.15s ease; }
.sidebar__fold[open] > summary::after { transform: rotate(45deg); }

.sidebar__link {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  height: 40px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-control);
  color: var(--text-inverse-muted);
  font-size: var(--fs-body);
  line-height: var(--lh-body);
  font-weight: var(--fw-medium);
  text-decoration: none;
  transition: background var(--t-fast), color var(--t-fast);
}

.sidebar__link:hover {
  background: var(--on-green-1);
  color: var(--text-inverse);
  text-decoration: none;
}

/* Выбранный пункт — поверхность плюс вес текста; hover на него не похож. */
.sidebar__link.is-active {
  background: var(--on-green-3);
  color: var(--text-inverse);
  font-weight: var(--fw-bold);
}

/* -------------------------------------------------------------- Персона */

.sidebar__persona {
  display: grid;
  gap: var(--sp-2);
  padding: var(--sp-3);
  border: 1px solid var(--on-green-line);
  border-radius: var(--r-control);
  background: var(--on-green-1);
}

.sidebar__personarow {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  min-width: 0;
}

.sidebar__personaicon {
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  border-radius: var(--r-tiny);
  background: var(--on-green-3);
  color: var(--text-inverse);
  display: grid;
  place-items: center;
}

.sidebar__personamain {
  display: grid;
  min-width: 0;
}

.sidebar__personaname {
  font-size: var(--fs-body);
  line-height: var(--lh-body);
  font-weight: var(--fw-bold);
  color: var(--text-inverse);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar__personarole {
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  color: var(--text-inverse-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar__switch {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  height: 32px;
  padding: 0 var(--sp-2);
  border: 0;
  border-radius: var(--r-tiny);
  background: transparent;
  color: var(--text-inverse-muted);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-semibold);
  transition: background var(--t-fast), color var(--t-fast);
}

.sidebar__switch:hover {
  background: var(--on-green-2);
  color: var(--text-inverse);
}

/* Переключатель языка (ADR-0019): тот же сегмент, что у трека данных, —
   тихий, на зелёном сайдбаре — инверсный. Самоназвание — в title и для
   диктора; на кнопке — короткая метка. */
.langsw {
  display: inline-flex;
  border: 1px solid var(--line-strong);
  border-radius: var(--r-pill);
  overflow: hidden;
  height: 28px;
  justify-self: start;
}

.langsw__btn {
  border: 0;
  background: transparent;
  padding: 0 var(--sp-3);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-bold);
  color: var(--muted);
  transition: background var(--t-fast), color var(--t-fast);
}

.langsw__btn:hover {
  background: var(--soft);
}

.langsw__btn.is-on {
  background: var(--deep);
  color: var(--text-inverse);
}

.sidebar__lang {
  /* Сайдбар — колонка с растущим меню: без запрета сжатия сегмент
     схлопывался в линию под ним. */
  flex-shrink: 0;
  align-self: flex-start;
  margin: 0 var(--sp-4) var(--sp-2);
  border-color: var(--on-green-2);
}

.sidebar__lang .langsw__btn {
  color: var(--text-inverse-muted);
}

.sidebar__lang .langsw__btn:hover {
  background: var(--on-green-2);
  color: var(--text-inverse);
}

.sidebar__lang .langsw__btn.is-on {
  background: var(--text-inverse);
  color: var(--deep);
}

.login__langrow {
  display: flex;
  justify-content: flex-end;
}

.sidebar__foot {
  padding: var(--sp-3);
  border-top: 1px solid var(--on-green-line);
  color: var(--text-inverse-muted);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
}

/* -------------------------------------------------------------- Topbar */

.main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.topbar {
  height: var(--h-topbar);
  flex: 0 0 var(--h-topbar);
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  padding: 0 var(--sp-6);
  background: var(--card);
  border-bottom: 1px solid var(--color-border-subtle);
  position: sticky;
  top: 0;
  z-index: 20;
}

.topbar__trail {
  min-width: 0;
  flex: 1 1 auto;
}

/* В шапке цепочка уровней — одна строка: шапка фиксированной высоты, и цепочка
   из четырёх уровней переносилась на три строки и обрезалась сверху
   (agroai-6al.38). Сжимается имя ТЕКУЩЕГО уровня (многоточие, полное — в
   подсказке); предки держат имя целиком. Когда места мало, у предков
   прячутся подписи уровней («ЦИКЛ», «СТАДИЯ») — имя важнее рода; заголовок
   страницы и так называет текущий уровень. */
.topbar__trail {
  container-type: inline-size;
}

.topbar__trail .trail {
  flex-wrap: nowrap;
  overflow: hidden;
}

.topbar__trail .trail__item {
  flex: 0 3 auto;
  min-width: 0;
}

/* Текущий уровень держит ~22 знака вместе с подписью уровня: раньше сжималось только его имя,
   и в кабинете хозяйства рядом с длинным именем массива от «Саркор»
   оставалось «С…». Теперь сперва (втрое быстрее) сжимаются имена средних
   предков (массив, цикл) — полное имя в подсказке; район (короткий корень)
   не сжимается. */
.topbar__trail .trail__item:first-child {
  flex-shrink: 0;
}

.topbar__trail .trail__item:last-child {
  flex: 0 1 auto;
  min-width: min(22ch, 100%);
}

@container (max-width: 420px) {
  /* Только у длинной цепочки (от трёх уровней): короткая помещается и так. */
  .topbar__trail .trail:has(> :nth-child(3)) .trail__level {
    display: none;
  }
}

.topbar__trail .trail__level,
.topbar__trail .trail__sep {
  flex: 0 0 auto;
  white-space: nowrap;
}

.topbar__tools {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  flex: 0 0 auto;
}

/* Чип персоны — тихий: он напоминает, чьими глазами открыт экран, и не
   соревнуется с датой среза за внимание. */
.topbar__persona {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  height: 32px;
  max-width: 240px;
  padding: 0 var(--sp-3);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--r-pill);
  background: var(--soft);
  color: var(--muted);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-semibold);
  white-space: nowrap;
}

/* Тот же чип, но кликабельный: у не вошедшего это единственный вход. */
.topbar__persona--in {
  cursor: pointer;
  color: var(--deep);
  background: var(--sage);
  border-color: var(--mint);
}

.topbar__personaname {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topbar__asof {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: 0 var(--sp-3);
  height: 32px;
  border-radius: var(--r-pill);
  background: var(--sage);
  color: var(--deep);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-semibold);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.tracksw {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.tracksw__label {
  font-size: var(--fs-label);
  line-height: var(--lh-label);
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  font-weight: var(--fw-bold);
  color: var(--muted);
}

.tracksw__group {
  display: flex;
  border: 1px solid var(--line-strong);
  border-radius: var(--r-pill);
  overflow: hidden;
  height: 32px;
}

.tracksw__btn {
  border: 0;
  background: transparent;
  padding: 0 var(--sp-3);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-bold);
  color: var(--muted);
  transition: background var(--t-fast), color var(--t-fast);
}

.tracksw__btn:hover {
  background: var(--soft);
}

.tracksw__btn.is-on {
  background: var(--deep);
  color: var(--text-inverse);
}

/* Поиск работает по срезу: контейнер держит выпадающий список, поле —
   обычный контрол высотой 32. Отключённой строки без объяснения тут больше нет. */
.searchbox {
  position: relative;
  min-width: 240px;
}

.searchbox__field {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  height: 32px;
  padding: 0 var(--sp-3);
  border: 1px solid var(--color-control-border);
  border-radius: var(--r-pill);
  color: var(--muted);
  background: var(--card);
  transition: border-color var(--t-fast), box-shadow var(--t-fast);
}

.searchbox__field:focus-within {
  border-color: var(--line-focus);
  box-shadow: var(--ring-focus);
}

.searchbox input {
  border: 0;
  outline: none;
  background: transparent;
  width: 100%;
  color: var(--ink);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
}

.searchbox input::placeholder {
  color: var(--muted);
}

.searchdrop {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 30;
  width: 360px;
  max-width: 70vw;
  display: grid;
  gap: 2px;
  padding: var(--sp-2);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--r-card);
  background: var(--card);
  box-shadow: var(--shadow-focus);
}

.searchdrop__hit {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  padding: var(--sp-2);
  border: 0;
  border-radius: var(--r-tiny);
  background: transparent;
  text-align: left;
  transition: background var(--t-fast);
}

.searchdrop__hit.is-on {
  background: var(--sage);
}

.searchdrop__icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  border-radius: var(--r-tiny);
  background: var(--soft);
  color: var(--muted);
}

.searchdrop__main {
  display: grid;
  gap: 1px;
  min-width: 0;
}

.searchdrop__title {
  font-size: var(--fs-body);
  line-height: var(--lh-body);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchdrop__note {
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  color: var(--muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Пустая выдача объясняет себя словами: «ничего не найдено» без причины
   неотличимо от сломанного поиска. */
.searchdrop__empty {
  padding: var(--sp-2);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  color: var(--muted);
}

/* ------------------------------------------------------------ Демо-слой */

.demolayer {
  position: relative;
}

.demolayer__trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  height: 32px;
  padding: 0 var(--sp-3);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--r-pill);
  background: var(--card);
  color: var(--muted);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-semibold);
  white-space: nowrap;
  transition: background var(--t-fast), color var(--t-fast), border-color var(--t-fast);
}

.demolayer__trigger:hover {
  background: var(--soft);
  color: var(--ink);
}

.demolayer__trigger[aria-expanded='true'] {
  background: var(--sage);
  border-color: var(--mint);
  color: var(--deep);
}

.demolayer__panel {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 30;
  width: 264px;
  max-width: 80vw;
  display: grid;
  gap: 2px;
  padding: var(--sp-2);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--r-card);
  background: var(--card);
  box-shadow: var(--shadow-focus);
}

.demolayer__caption {
  padding: var(--sp-2) var(--sp-2) var(--sp-1);
  color: var(--muted);
}

.demolayer__item {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  height: 36px;
  padding: 0 var(--sp-2);
  border: 0;
  border-radius: var(--r-tiny);
  background: transparent;
  text-align: left;
  color: var(--ink);
  font-size: var(--fs-caption);
  line-height: var(--lh-caption);
  font-weight: var(--fw-semibold);
  transition: background var(--t-fast);
}

.demolayer__item:hover {
  background: var(--soft);
}

.demolayer__item:disabled {
  color: var(--action-disabled-fg);
  cursor: default;
}

.demolayer__item:disabled:hover {
  background: transparent;
}

.demolayer__status {
  padding: var(--sp-2);
  color: var(--deep);
}

/* Отказ загрузки — та же медь, что и у прочих инлайн-ошибок формы в прототипе
   (см. TemplateDetail/addwork__error): не статус-заливка, а цвет текста. */
.demolayer__status--fail {
  color: var(--copper-deep);
}

/* ------------------------------------------------------------ Content */

.content {
  flex: 1 1 auto;
  padding: var(--sp-6);
  display: flex;
  justify-content: center;
  min-width: 0;
}

.content__inner {
  width: 100%;
  max-width: var(--w-content-max);
  display: grid;
  /* Явная колонка с нулевым минимумом: иначе широкая таблица внутри стопки
     растягивает неявную колонку и вбок едет вся страница (см. ui.css). */
  grid-template-columns: minmax(0, 1fr);
  gap: var(--sp-6);
  align-content: start;
}

.content__inner > * {
  min-width: 0;
}

.content--wide .content__inner {
  max-width: none;
}

/* Экраны кабинета (`.astra`) строятся на широкой сетке: у них колонки,
   карта и таблицы рядом. Наследие остаётся в колонке чтения. */
.content[data-layout='astra'] .content__inner {
  max-width: var(--w-content-wide);
}

@media (max-width: 1279px) {
  .shell {
    grid-template-columns: 72px minmax(0, 1fr);
  }

  .sidebar__link span:last-child,
  .sidebar__brand > div,
  .sidebar__foot {
    display: none;
  }

  .sidebar__link {
    justify-content: center;
  }

  /* Подпись раздела схлопывается, линия остаётся: «Управление» без текста
     всё ещё читается как отдельная группа. */
  .sidebar__group {
    font-size: 0;
    letter-spacing: 0;
    padding: var(--sp-3) 0 0;
  }

  .sidebar__persona {
    padding: var(--sp-2);
    justify-items: center;
  }

  .sidebar__personamain,
  .sidebar__switch span {
    display: none;
  }

  .sidebar__personarow {
    justify-content: center;
  }

  /* В узкой колонке три языка встают столбиком. */
  .sidebar__lang {
    flex-direction: column;
    height: auto;
    align-self: center;
    margin: 0 0 var(--sp-2);
    border-radius: var(--r-tiny);
  }

  .sidebar__lang .langsw__btn {
    height: 24px;
    padding: 0 var(--sp-2);
  }

  .sidebar__switch {
    width: 32px;
    padding: 0;
    justify-content: center;
  }

  .topbar__persona {
    max-width: 168px;
  }

  /* Подпись схлопывается вслед за сайдбаром — значок FlaskConical и рамка
     пилюли остаются, чтобы кнопка не пропала совсем. */
  .demolayer__trigger span {
    display: none;
  }

  .demolayer__trigger {
    padding: 0 var(--sp-2);
  }

  .searchbox {
    display: none;
  }
}

/* Кнопка меню и подложка есть только на телефоне. */
.topbar__menu,
.shell__backdrop {
  display: none;
}

/*
 * Телефон (К4, 07.10.2026): рельс меню 56 px занимал 15 % ширины на каждом
 * экране. Теперь меню — выезжающая панель по кнопке «☰» в шапке, с подписями,
 * как на широком экране; в шапке — имя текущего экрана (последняя ступень
 * цепочки). Закрывается переходом, подложкой и Esc. Закрытая панель
 * `visibility: hidden` — клавиатура в неё не попадает.
 */
@media (max-width: 600px) {
  .shell { grid-template-columns: minmax(0, 1fr); }
  .sidebar {
    position: fixed;
    inset: 0 auto 0 0;
    z-index: 95;
    width: min(288px, 86vw);
    height: 100dvh;
    padding: var(--sp-4) var(--sp-3);
    gap: var(--sp-4);
    overflow-y: auto;
    transform: translateX(-100%);
    visibility: hidden;
    transition: transform var(--t-fast), visibility var(--t-fast);
  }
  .sidebar--open { transform: none; visibility: visible; box-shadow: var(--shadow-hero); }
  .sidebar__nav { min-height: 0; overflow-y: auto; }

  /* В панели — подписи, как на широком экране (≤1279 их прятал рельс). */
  .sidebar__link span:last-child,
  .sidebar__brand > div,
  .sidebar__foot,
  .sidebar__switch span { display: revert; }
  .sidebar__personamain { display: grid; }
  .sidebar__link { justify-content: flex-start; padding: 0 var(--sp-3); }
  .sidebar__brand { padding: 0 var(--sp-3); justify-content: flex-start; }
  .sidebar__group {
    font-size: var(--fs-label);
    letter-spacing: var(--ls-label);
    padding: var(--sp-3) var(--sp-3) var(--sp-1);
  }
  .sidebar__persona { padding: var(--sp-3); justify-items: stretch; }
  .sidebar__personarow { justify-content: flex-start; }
  .sidebar__switch { width: auto; padding: 0 var(--sp-2); justify-content: flex-start; }

  .shell__backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 94;
    border: 0;
    padding: 0;
    background: color-mix(in srgb, var(--ink) 40%, transparent);
  }

  .topbar { padding: 0 var(--sp-3); gap: var(--sp-2); }
  .topbar__menu {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: var(--h-control-sm);
    height: var(--h-control-sm);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--r-control);
    background: var(--card);
    color: var(--deep);
  }
  /* Из цепочки — только имя текущего экрана. */
  .topbar__trail .trail__item:not(:last-child),
  .topbar__trail .trail__sep,
  .topbar__trail .trail__level { display: none; }
  .topbar__trail .trail__item:last-child { min-width: 0; }
  .topbar__persona { display: none; }
  .topbar__tools { gap: var(--sp-2); }
  .tracksw__label { display: none; }
  .content { padding: 20px 14px; }
}

/* Analytical surfaces use the workspace; prose limits stay inside individual panels. */
@media (min-width: 1600px) { .content { padding: 28px clamp(28px, 2vw, 56px); } }
.sidebar { overflow-y: auto; }
